// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__3px7Q","badge_animate":"Badge_badge_animate__F-evL","shake":"Badge_shake__1sUUZ","blink":"Badge_blink__3lh3R"};